module.exports = require('./helpers/bundle-url').getBundleURL('gnRNX') + "03billing.a037b1d2.png" + "?" + Date.now();